import React, { useContext } from 'react';
import classes from './ContactUs.module.css';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../App';

export default function ContactUs() {
  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.container}>
      <div className={classes.content}>
        <h3 className="text-smBtwPages md:text-mdBtwPages md:w-4/5 lg:w-full lg:text-lgBtwPages">
          Let's discuss your full-stack development needs
        </h3>
        <Link to="/contactUs" className="w-2/5 mx-auto flex items-center">
          <button
            className={
              classes.contactBtn +
              ' mx-auto text-smSepBtnTxt p-2vh10vw md:text-mdSepBtnTxt lg:text-lgSepBtnTxt lg:p-2vh4vw z-10'
            }
          >
            Contact&nbsp;us
          </button>
        </Link>
      </div>
    </div>
  );
}
